import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';

const icons = {
  CloudDownloadOutlinedIcon
};

const downloadPicture = {
  id: 'batch-picture-download',
  type: 'group',
  children: [
    {
      id: 'Download Batch Picture',
      title: 'Download Batch Picture',
      type: 'item',
      url: '/Download_Batch_Picture',
      icon: icons.CloudDownloadOutlinedIcon,
    }
  ]
};

export default downloadPicture;
